import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { getI18n } from 'react-i18next';
import { Typography } from 'antd';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import { CellText } from '~/pages/agent/components/agent/tableElements/cells/CellText';
import longdash from '~/constants/longdash';
import { openNewApplicationTab } from '~/utils/goToApplication';
import { AgentLead } from '~/types/AgentLead';

function getLeadApplicationId(record: AgentLead) {
  return record.applicationId;
}

function getLeadApplicationDisplayId(record: AgentLead) {
  return record.applicationDisplayId;
}

function leadApplicationIdCell(): ColumnsType<AgentLead>[0] {
  return {
    title: () => (
      <TableHeader
        title={getI18n().t('Application ID', { ns: 'agent' })}
        sortingDataKey="applicationId"
      />
    ),
    dataIndex: 'applicationId',
    key: 'applicationId',
    render: (_: unknown, record: AgentLead) => {
      const applicationId = getLeadApplicationId(record);
      const displayId = getLeadApplicationDisplayId(record);

      if (!displayId) {
        return <CellText>{longdash}</CellText>;
      }

      return (
        <CellText>
          <Typography.Link
            onClick={(e) => {
              e.stopPropagation();
              if (applicationId) {
                openNewApplicationTab(applicationId);
              }
            }}
          >
            {displayId}
          </Typography.Link>
        </CellText>
      );
    },
    width: 160,
  };
}

export default leadApplicationIdCell;
